export default __webpack_public_path__ + "static/media/smoothie-8.4f9c7836.svg";